export const HANGOVER_QUESTIONS = {
    safety: {
        id: 'safety',
        number: 1,
        text: 'First, let\'s confirm, do you currently have any of the following conditions?',
        hint: 'For your health and safety, we need to know these first',
        type: 'checkbox',
        options: [
            { value: 'pregnant', label: '🤰 Pregnant or breastfeeding' },
            { value: 'liver_disease', label: '🩺 Have liver disease (e.g., hepatitis, fatty liver, cirrhosis)' },
            { value: 'liver_medication', label: '💊 Taking liver protection medication' },
            { value: 'alcohol_dependence', label: '⚠️ Alcohol dependence or addiction' },
            { value: 'none', label: '✓ None of the above, continue', exclusive: true }
        ]
    },

    demographics: {
        id: 'demographics',
        number: 2,
        text: 'Tell us some basic information',
        type: 'multi-part',
        parts: [
            {
                id: 'age',
                label: 'Age Group',
                type: 'radio',
                options: [
                    { value: '21-30', label: '21-30 years' },
                    { value: '31-40', label: '31-40 years' },
                    { value: '41-50', label: '41-50 years' },
                    { value: '51-65', label: '51-65 years' },
                    { value: 'other', label: 'Other age group' }
                ]
            },
            {
                id: 'weight',
                label: 'Weight',
                type: 'radio',
                options: [
                    { value: '<150', label: '< 150 lbs (< 68 kg)' },
                    { value: '150-180', label: '150-180 lbs (68-82 kg)' },
                    { value: '180-220', label: '180-220 lbs (82-100 kg)' },
                    { value: '>220', label: '> 220 lbs (> 100 kg)' }
                ]
            }
        ]
    },

    mainConcern: {
        id: 'mainConcern',
        number: 3,
        text: 'What do you mainly want to solve?',
        type: 'radio',
        options: [
            { value: 'regular_drinker', label: '🍺 Regular drinker, want daily liver care' },
            { value: 'hangover', label: '🤢 Uncomfortable after drinking (hangover, headache)' },
            { value: 'occasional', label: '🎉 Occasional parties, need to relieve post-drinking discomfort' },
            { value: 'reduce', label: '🌿 Want to reduce drinking or improve drinking habits' }
        ]
    },

    // 分支A：经常喝酒
    drinkingFrequency: {
        id: 'drinkingFrequency',
        number: 4,
        text: 'Your drinking frequency?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'regular_drinker',
        options: [
            { value: 'daily', label: 'Drink every day' },
            { value: '4-6_week', label: '4-6 times a week' },
            { value: '2-3_week', label: '2-3 times a week' }
        ]
    },

    alcoholType: {
        id: 'alcoholType',
        number: 5,
        text: 'What do you mainly drink?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'regular_drinker',
        options: [
            { value: 'beer', label: '🍺 Beer' },
            { value: 'wine', label: '🍷 Red/White Wine' },
            { value: 'spirits', label: '🥃 Spirits (Whiskey, Vodka, Rum, etc.)' },
            { value: 'cocktails', label: '🍹 Cocktails' }
        ]
    },

    drinkingAmount: {
        id: 'drinkingAmount',
        number: 6,
        text: 'How much do you drink each time?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'regular_drinker',
        options: [
            { value: '1-2', label: '1-2 drinks' },
            { value: '3-4', label: '3-4 drinks' },
            { value: '5+', label: '5+ drinks' }
        ]
    },

    afterEffects: {
        id: 'afterEffects',
        number: 7,
        text: 'Feeling after drinking?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'regular_drinker',
        options: [
            { value: 'dry_mouth', label: 'Easily inflamed, dry mouth' },
            { value: 'fatigue', label: 'Fatigue next day, poor spirit' },
            { value: 'stomach', label: 'Stomach discomfort' },
            { value: 'sleep', label: 'Poor sleep quality' },
            { value: 'none', label: 'Basically no discomfort', exclusive: true }
        ]
    },

    // 分支B：宿醉不适
    hangoverSymptoms: {
        id: 'hangoverSymptoms',
        number: 4,
        text: 'Main discomfort symptoms?',
        hint: 'Select 1-3 that bother you the most',
        type: 'checkbox',
        maxSelect: 3,
        condition: (answers) => answers.mainConcern === 'hangover',
        options: [
            { value: 'headache', label: '🤕 Headache, dizziness' },
            { value: 'nausea', label: '🤢 Nausea, wanting to vomit' },
            { value: 'fatigue', label: '😫 General weakness' },
            { value: 'dehydration', label: '💧 Severe dry mouth, thirst' },
            { value: 'brain_fog', label: '😴 Brain fog, poor spirit' },
            { value: 'vertigo', label: '🌀 Vertigo, room spinning sensation' }
        ]
    },

    hangoverDuration: {
        id: 'hangoverDuration',
        number: 5,
        text: 'How long do these symptoms usually last?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'hangover',
        options: [
            { value: '2-4hrs', label: '2-4 hours' },
            { value: 'half_day', label: 'About half a day' },
            { value: 'full_day', label: 'A full day or longer' }
        ]
    },

    hangoverFrequency: {
        id: 'hangoverFrequency',
        number: 6,
        text: 'How often do you drink?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'hangover',
        options: [
            { value: 'weekly', label: 'Drink every week' },
            { value: 'monthly', label: 'Several times a month' },
            { value: 'occasional', label: 'Only occasionally (holidays, parties)' }
        ]
    },

    // 分支C：偶尔聚会
    socialFrequency: {
        id: 'socialFrequency',
        number: 4,
        text: 'Party drinking frequency?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'occasional',
        options: [
            { value: '2-4_month', label: '2-4 times a month' },
            { value: '1_month', label: 'About once a month' },
            { value: 'rare', label: 'Once every few months' }
        ]
    },

    socialAlcoholType: {
        id: 'socialAlcoholType',
        number: 5,
        text: 'What do you usually drink at parties?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'occasional',
        options: [
            { value: 'beer', label: '🍺 Beer' },
            { value: 'wine', label: '🍷 Red/White Wine' },
            { value: 'shots', label: '🥃 Spirits shots (Whiskey, Tequila shots)' },
            { value: 'cocktails', label: '🍹 Cocktails' }
        ]
    },

    socialConcerns: {
        id: 'socialConcerns',
        number: 6,
        text: 'Most worried about?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'occasional',
        options: [
            { value: 'next_day', label: 'Fear hangover affecting work next day' },
            { value: 'overdrink', label: 'Worry about drinking too much and losing control' },
            { value: 'health', label: 'Worry about liver damage and health' },
            { value: 'stomach', label: 'Worry about stomach discomfort' }
        ]
    },

    // 分支D：减少饮酒
    reduceGoal: {
        id: 'reduceGoal',
        number: 4,
        text: 'Your situation?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'reduce',
        options: [
            { value: 'quit', label: 'Want to quit drinking completely' },
            { value: 'reduce', label: 'Want to reduce drinking frequency or amount' },
            { value: 'improve', label: 'Want to improve post-drinking discomfort to help drink less' }
        ]
    },

    currentDrinking: {
        id: 'currentDrinking',
        number: 5,
        text: 'Current drinking situation?',
        type: 'radio',
        condition: (answers) => answers.mainConcern === 'reduce',
        options: [
            { value: 'daily', label: 'Drink almost every day' },
            { value: '3-5_week', label: 'Drink 3-5 times a week' },
            { value: '1-2_week', label: 'Drink 1-2 times a week' }
        ]
    },

    reduceChallenges: {
        id: 'reduceChallenges',
        number: 6,
        text: 'Main troubles?',
        hint: 'Select all that apply',
        type: 'checkbox',
        condition: (answers) => answers.mainConcern === 'reduce',
        options: [
            { value: 'social_pressure', label: 'High social pressure, have to drink' },
            { value: 'habit', label: 'Habit of having a drink after work' },
            { value: 'health_concern', label: 'Worried about health issues' },
            { value: 'sleep_energy', label: 'Want to improve sleep and energy' }
        ]
    },

    // 通用问题
    constitution: {
        id: 'constitution',
        number: 7,
        text: 'Your constitution characteristics?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'heat', label: '🔥 Easily inflamed, dry/bitter mouth' },
            { value: 'thirsty', label: '💧 Thirsty, always want to drink water' },
            { value: 'sweating', label: '😓 Easily sweat' },
            { value: 'cold_limbs', label: '🧊 Cold hands and feet' },
            { value: 'none', label: 'None of the above', exclusive: true }
        ]
    },

    otherSymptoms: {
        id: 'otherSymptoms',
        number: 8,
        text: 'Do you also have these conditions?',
        hint: 'Select all that apply',
        type: 'checkbox',
        options: [
            { value: 'stomach', label: '🤢 Bad stomach (bloating, pain, acid)' },
            { value: 'sleep', label: '😴 Poor sleep quality' },
            { value: 'stress', label: '😰 High stress, anxiety' },
            { value: 'digestion', label: '💩 Poor digestion or constipation' },
            { value: 'none', label: 'None of the above', exclusive: true }
        ]
    },

    liverCheck: {
        id: 'liverCheck',
        number: 9,
        text: 'Have you had a liver function test?',
        type: 'radio',
        condition: (answers) => {
            // 经常喝酒或想减酒的人才问
            if (answers.mainConcern === 'regular_drinker' || answers.mainConcern === 'reduce') {
                return true;
            }
            // 或者宿醉频率高的人
            if (answers.mainConcern === 'hangover' && answers.hangoverFrequency === 'weekly') {
                return true;
            }
            return false;
        },
        options: [
            { value: 'normal', label: 'Yes, results are normal' },
            { value: 'elevated', label: 'Yes, some indicators are high (e.g., ALT, AST)' },
            { value: 'no_check', label: 'Have not checked' }
        ]
    }
};